import React from "react";
import { Card, Row, Col } from "antd";
import { Table } from "components";
import PropTypes from "prop-types";
import { ERP_REQUEST_SOURCE, ERP_REQUEST_TYPE, ERP_REQUEST_CURRENT_STATUS } from "./constants/enums";
import {  OrderedMap } from "immutable";
import { TABLE_DATA_TYPES } from "constants/table-data-types";
import moment from "moment";

const VISIBILITY_COLS = new OrderedMap({
    create_date: {
        title: "Date",
        dataIndex: "create_date",
        key: "create_date",
        dataType: TABLE_DATA_TYPES.STRING,
        width: 120,
        align: "center",
        render: _ => _ ? moment(_).format("DD/MM/YYYY") : "--"
    },
    "company.name": {
        title: "Company",
        dataIndex: "company.name",
        key: "company.name",
        dataType: TABLE_DATA_TYPES.STRING,
        width: 120,
        align: "center",
    },
    request_source: {
        title: "Request Source",
        dataIndex: "request_source",
        key: "request_source",
        dataType: TABLE_DATA_TYPES.STRING,
        width: 120,
        align: "center",
        render: _ => _ ? ERP_REQUEST_SOURCE.findKey(__ => Number(__) === Number(_)) : "--"
    },
    request_type: {
        title: "Request Type",
        dataIndex: "request_type",
        key: "request_type",
        dataType: TABLE_DATA_TYPES.STRING,
        width: 120,
        align: "center",
        render: _ => _ ? ERP_REQUEST_TYPE.findKey(__ => Number(__) === Number(_)) : "--"
    },
    ledger_status: {
        title: "Ledgers",
        dataIndex: "ledger_status",
        key: "ledger_status",
        dataType: TABLE_DATA_TYPES.STRING,
        width: 120,
        align: "center",
        render: _ => _ && _.length ? _.reduce((agg, __) => +__.count + agg, 0) : "--"
    },
    current_status: {
        title: "Current Status",
        dataIndex: "current_status",
        key: "current_status",
        dataType: TABLE_DATA_TYPES.STRING,
        width: 120,
        align: "center",
        render: _ => _ ? ERP_REQUEST_CURRENT_STATUS.findKey(__ => Number(__) === Number(_)) : "--"
    }
});

class RequestTable extends React.Component {
    state = {
        currentPage: 1,
    };
    onPageChange = (page, page_size) => {
        this.props.pagination(page, page_size);
        this.setState({currentPage: page});
    };


    onPageSizeChange = (page, page_size) => {
        this.props.pagination(page, page_size);
    };
    render() {
        return(
            <Row>
                <Col offset={3} span={18}>
                    <Card title={"Previous Requests"} className={"padless-card"}>
                        <Table
                            columns={VISIBILITY_COLS}
                            loading={this.props.tableLoading}
                            showTopSection={false}
                            showPaginationOnly={false}
                            tablePagination={true}
                            footer={false}
                            noRowSelection={true}
                            data={this.props.requests}
                            showTotalPages={true}
                            pagination={{
                                current: this.state.currentPage,
                                defaultPageSize: 20,
                                showSizeChanger: true,
                                pageSizeOptions: [
                                    "20",
                                    "50",
                                    "100",
                                    "500"
                                ],
                                position: "bottom",
                                defaultCurrent: 1, 
                                showFooter: false,
                                total: this.props.requestsCount,
                                onChange: (page, pageSize) =>
                                    this.onPageChange(page, pageSize),
                                onShowSizeChange: this.onPageSizeChange,
                                // showTotal:(total, range) => `Showing ${range[0]}-${range[1]} of ${total} items`
                            }}
                        />
                    </Card>
                </Col>
            </Row>
        );
    }
}

RequestTable.propTypes={
    requests: PropTypes.array,
    tableLoading: PropTypes.bool,
    pagination: PropTypes.func,
    requestsCount: PropTypes.number
};

export default RequestTable;